import type { App } from 'vue'
import { type _Formatter, setupFormatter, useFormatter } from '@/composables/useFormatter.ts'
import type { I18nType } from '@/helpers/i18n.ts'

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $formatter: _Formatter
  }
}
export default function (i18n: I18nType['global']) {
  return {
    install: (app: App) => {
      setupFormatter(i18n.t)
      app.config.globalProperties.$formatter = useFormatter()
    }
  }
}
